
export default {
  name: 'MoleculeProjectSliderThumb'
}
